window.addEventListener('DOMContentLoaded', (event) => {
    $('.carousel').carousel({
        interval: 4000
    });
    count = 0;
    $('.carousel').on('slide.bs.carousel', function () {
        wordsArray = [
            'staff',
            'students',
            'friends',
            'team mates'
        ];
        numbersArray = [
            '9/10',
            '5/10',
            '8/10',
            '6/10'
        ];
        count++;
        $('#balance').fadeOut(100, function () {
            $(this).text(wordsArray[count % wordsArray.length]).fadeIn(500, function () {
                animateRotate(90 * count);
            });
        });
        $('#wheelNumber').text(numbersArray[count % numbersArray.length]).fadeIn(200);
        // Reset animation when 360
        if (count > 4) {
            count = 1;
            $('#wheel').animate(
                {deg: 0},
                {
                    duration: 0,
                    step: function (now) {
                        $(this).css({transform: 'rotate(' + now + 'deg)'});
                    }
                }
            );
        }
    });

    function animateRotate(angle) {
        $('#wheel').animate(
            {deg: -angle},
            {
                duration: 1200,
                step: function (now) {
                    $(this).css({transform: 'rotate(' + now + 'deg)'});
                }
            }
        );
    }
});